import {Component} from '@angular/core';
import {Shoppingcard} from '../../../model/Shoppingcard';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {BuyBalanceService} from '../../../service/buy-balance.service';
import {Constant} from '../../../../global/util/Constant';
import {InformType} from '../../../../global/util/enum/InformType';
import {Dialog} from '../../../../global/util/Dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-balance',
  templateUrl: './buy-balance.component.html',
  styleUrls: ['./buy-balance.component.css']
})
export class BuyBalanceComponent {

  public shoppingcards: Shoppingcard[];
  public loading: boolean;

  constructor(private buyBalanceService: BuyBalanceService,
              private translate: TranslateService) {
    this.loadDefaultData();
  }

  private loadDefaultData(): void {
    this.loadShoppingcards();
  }

  private loadShoppingcards(): void {
    this.loading = true;
    const url = Constant.ROOT_API_V1 + '/partners/' + LocalStorage.getPartnerId() + '/shoppingbalances';
    this.buyBalanceService.get(url).subscribe((value: any) => {
      this.loading = false;
      if (value._embedded) {
        this.shoppingcards = value._embedded.shoppingcards;
      } else {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.BUY-BAGS'), this.translate.instant('MESSAGE.DOES-NOT-HAVE-BAGS-OF-PRODUCTS-AVAILABLE'));
      }
    }, error => {
      this.loading = false;
    });
  }
}
